// privatokonomi-messages-part3 translations (Norwegian source catalog).
window.PlummeI18n.register('no', {
  'pkn.tw.step.situation': 'Din situasjon',
  'pkn.tw.step.income': 'Inntekt',
  'pkn.tw.step.workTravel': 'Arbeid og reise',
  'pkn.tw.step.housingDebt': 'Bolig og gjeld',
  'pkn.tw.step.family': 'Familie',
  'pkn.tw.step.savingsInvesting': 'Sparing og investering',
  'pkn.tw.step.otherMatters': 'Andre forhold',
  'pkn.tw.step.business': 'Næring',
  'pkn.tw.step.deductions': 'Fradrag',
  'pkn.tw.step.summary': 'Oppsummering',
  'pkn.acc.fillName': 'Fyll inn kontonavn',
  'pkn.acc.editAccount': 'Rediger konto',
  'pkn.acc.addAccount': 'Legg til konto',
  'pkn.acc.fieldName': 'Kontonavn',
  'pkn.acc.phName': 'F.eks. DNB brukskonto',
  'pkn.acc.fieldNumber': 'Kontonummer',
  'pkn.acc.phNumber': 'F.eks. 1234.56.78901',
  'pkn.acc.openingBalance': 'Inngående saldo (kr)',
  'pkn.acc.closingBalance': 'Utgående saldo (kr)',
  'pkn.acc.numberHint': 'Kontonummer gjør det enklere å matche fremtidige kontoutskrifter mot riktig konto. Bruk minus for kredittgjeld, f.eks. −12400.',
  'pkn.acc.account': 'Konto',
  'pkn.acc.accountLower': 'konto',
  'pkn.acc.theAccount': 'kontoen',
  'pkn.acc.theStatement': 'kontoutskriften',
  'pkn.acc.noNumber': 'Uten kontonummer',
  'pkn.acc.noBalance': 'Ingen saldo',
  'pkn.acc.transactionsCount': '{count} transaksjoner',
  'pkn.acc.statementOne': '{count} kontoutskrift',
  'pkn.acc.statementMany': '{count} kontoutskrifter',
  'pkn.acc.kpi.read': 'Transaksjoner lest',
  'pkn.acc.kpi.statements': 'Utskrifter',
  'pkn.acc.kpi.categories': 'Kategorier',
  'pkn.acc.kpi.unprocessed': 'Ubehandlede',
  'pkn.acc.statementsFor': 'Kontoutskrifter for {year} importert til {name}',
  'pkn.acc.noStatementsForYear': 'Ingen kontoutskrifter for {year} er koblet til denne kontoen. Velg et annet år eller last opp en fil under «Importer økonomiske data».',
  'pkn.acc.statement': 'Kontoutskrift',
  'pkn.acc.uploaded': 'Lastet opp',
  'pkn.acc.readIn': 'Lest inn',
  'pkn.acc.failed': 'Feilet',
  'pkn.acc.reading': 'Leser inn …',
  'pkn.acc.deleteTitle': 'Slette {name}?',
  'pkn.acc.deleteAccount': 'Slett konto',
  'pkn.acc.deleteWith': 'Kontoen slettes sammen med',
  'pkn.acc.and': 'og',
  'pkn.acc.linkedCannotUndo': 'som er koblet til den. Dette kan ikke angres.',
  'pkn.acc.deletePermanent': 'Kontoen slettes permanent. Dette kan ikke angres.',
  'pkn.acc.deleting': 'Sletter',
  'pkn.acc.deletingSuffix': 'og alle transaksjonene som ble lest fra den. Dette kan ikke angres.',
  'pkn.acc.noAccounts': 'Ingen kontoer er registrert ennå. Trykk «Legg til konto» for å registrere brukskonto, sparekonto eller kredittkort — eller velg kontonavn når du laster opp en kontoutskrift.',
  'pkn.acc.noAccountsOfType': 'Ingen kontoer av denne typen.',
  'pkn.acc.cardStatementOne': '{count} utskrift',
  'pkn.acc.cardStatementMany': '{count} utskrifter',
  'pkn.imp.beingRead': 'Leses inn …',
  'pkn.imp.pickAccountFor': 'Velg hvilken konto utskriften hører til.',
  'pkn.imp.numberHint': 'Kontonummer gjør det enklere å matche fremtidige kontoutskrifter og bankintegrasjon mot riktig konto.',
  'pkn.imp.accounts': 'Kontoer',
  'pkn.imp.statements': 'Kontoutskrifter',
  'pkn.imp.sayA': 'Last opp en kontoutskrift, så leser',
  'pkn.imp.sayB': 'av hver transaksjon, kobler den til riktig konto og kategoriserer automatisk. Du trenger ikke gjøre noe manuelt — jeg holder økonomien din oppdatert i bakgrunnen.',
  'pkn.imp.recategorising': 'Kategoriserer …',
  'pkn.imp.recategorise': 'Kategoriser på nytt',
  'pkn.imp.uploadingDots': 'Laster opp …',
  'pkn.imp.dropHere': 'Dra og slipp filer her',
  'pkn.imp.dropSub': 'Kontoutskrifter, kredittkortutskrifter og CSV-eksport. Du velger konto i neste steg. XLSX og CSV leses direkte, PDF leses best effort fra tekst.',
  'pkn.imp.uploading': 'Laster opp',
  'pkn.imp.chooseFiles': 'Velg filer',
  'pkn.imp.fetching': 'Henter importstatus …',
  'pkn.imp.unlinkedNote': 'Disse kontoutskriftene mangler konto. Koble dem til en konto for å få dem inn i oversikten.',
  'pkn.imp.upload': 'Last opp',
  'pkn.kat.sort.date-desc': 'Nyeste først',
  'pkn.kat.sort.date-asc': 'Eldste først',
  'pkn.kat.sort.amt-desc': 'Høyest beløp',
  'pkn.kat.sort.amt-asc': 'Lavest beløp',
  'pkn.kat.tips.housing.1': 'Bytt strømavtale — spotpris kan være rimeligere enn fastpris',
  'pkn.kat.tips.housing.2': 'Se over TV- og bredbåndsabonnement du ikke bruker fullt ut',
  'pkn.kat.tips.housing.3': 'Sjekk om boliglånsrenten kan forhandles ned',
  'pkn.kat.tips.food.1': 'Handle med ukesliste — impulskjøp står for en stor del',
  'pkn.kat.tips.food.2': 'Bytt til kjedenes egne varer på det du kjøper ofte',
  'pkn.kat.tips.food.3': 'Storhandle sjeldnere for mindre svinn og færre impulskjøp',
  'pkn.kat.tips.shopping.1': 'Legg varer i handlekurven og vent 48 timer før du kjøper',
  'pkn.kat.tips.shopping.2': 'Sett et fast månedlig shoppingbudsjett',
  'pkn.kat.tips.shopping.3': 'Meld deg av nyhetsbrev og appvarsler som frister til kjøp',
  'pkn.kat.tips.transport.1': 'Vurder månedskort framfor enkeltbilletter',
  'pkn.kat.tips.transport.2': 'Sykle eller gå korte turer du i dag kjører',
  'pkn.kat.tips.transport.3': 'Fyll drivstoff på den rimeligste kjeden i nærområdet',
  'pkn.kat.tips.dining.1': 'Sett en ukentlig grense for uteliv',
  'pkn.kat.tips.dining.2': 'Bytt to takeaway-kvelder i uka med hjemmelaget mat',
  'pkn.kat.tips.dining.3': 'Bestill henting i stedet for levering — du sparer gebyr og tips',
  'pkn.kat.tips.travel.1': 'Bestill fly 6–8 uker før avreise for lavere pris',
  'pkn.kat.tips.travel.2': 'Reis utenom skoleferier når det er mulig',
  'pkn.kat.tips.travel.3': 'Bruk bonuspoeng du allerede har spart opp',
  'pkn.kat.tips.insurance.1': 'Samle forsikringene hos én leverandør for samlerabatt',
  'pkn.kat.tips.insurance.2': 'Sjekk at dekningen faktisk matcher behovet ditt',
  'pkn.kat.tips.insurance.3': 'Øk egenandelen litt for lavere månedspremie',
  'pkn.kat.tips.subscriptions.1': 'Si opp tjenester du ikke har brukt de siste 30 dagene',
  'pkn.kat.tips.subscriptions.2': 'Del familieabonnement på strømming i stedet for egne',
  'pkn.kat.tips.subscriptions.3': 'Bytt til årlig betaling der det er rimeligere enn månedlig',
  'pkn.kat.tips.default.1': 'Sett et månedlig tak for kategorien',
  'pkn.kat.tips.default.2': 'Se over faste trekk du kan justere eller si opp',
  'pkn.kat.tips.default.3': 'Flytt det du sparer rett til et sparemål',
  'pkn.kat.importedStatement': 'Importert kontoutskrift',
  'pkn.kat.unknown': 'Ukjent',
  'pkn.kat.leadEmpty': 'Det er ingen importerte transaksjoner i {category} for denne perioden ennå.',
  'pkn.kat.leadOne': '{category} utgjør {total} fordelt på {count} transaksjon, med et snitt på {average} per kjøp.',
  'pkn.kat.leadMany': '{category} utgjør {total} fordelt på {count} transaksjoner, med et snitt på {average} per kjøp.',
  'pkn.kat.topItem': 'Størst enkeltpost er {name}, der du har brukt {amount}.',
  'pkn.kat.changeUp': 'Kategorien økte {pct} % mot forrige måned.',
  'pkn.kat.changeDown': 'Kategorien falt {pct} % mot forrige måned.',
  'pkn.kat.lineOne': '{count} linje',
  'pkn.kat.lineMany': '{count} linjer',
  'pkn.kat.moving': 'Flytter …',
  'pkn.kat.move': 'Flytt',
  'pkn.kat.vsPrev': 'vs. forrige mnd',
  'pkn.kat.timesAverage': '{factor}× snittet',
  'pkn.kat.howToCut': 'Slik kan du kutte',
  'pkn.kat.potential': 'Potensial ~{amount}/mnd',
  'pkn.kat.clearAll': 'Fjern alle',
  'pkn.kat.selectAll': 'Velg alle',
  'pkn.kat.learn': 'Lær av valget for fremtidige importer',
  'pkn.kat.noTxInCategory': 'Ingen transaksjoner i denne kategorien.',
  'pkn.kat.noTxMatchSearch': 'Ingen transaksjoner matcher søket.',
  'pkn.sce.notCalculable': 'Ikke beregnbar',
  'pkn.sce.base.label': 'Dagens plan',
  'pkn.sce.base.story': 'Med dagens plan — {save} i sparing og {debt} i ekstra gjeldsnedbetaling hver måned — er dette kursen økonomien din ligger på. Alle scenariene under regnes fra dette utgangspunktet.',
  'pkn.sce.saving.label': 'Øke sparingen',
  'pkn.sce.saving.field': 'Ekstra sparing per måned',
  'pkn.sce.saving.statExtra': 'Ekstra sparing',
  'pkn.sce.saving.stat5y': 'På 5 år',
  'pkn.sce.saving.story': 'Legger du {amount} ekstra til side i måneden, vokser formuen merkbart raskere. Målene nås i snitt flere måneder tidligere.',
  'pkn.sce.home.label': 'Kjøpe bolig',
  'pkn.sce.home.price': 'Boligpris',
  'pkn.sce.equity': 'Egenkapital',
  'pkn.sce.rate': 'Rente',
  'pkn.sce.term': 'Lånetid',
  'pkn.sce.loanType': 'Lånetype',
  'pkn.sce.annuity': 'Annuitet',
  'pkn.sce.serial': 'Serie',
  'pkn.sce.loan': 'Lån',
  'pkn.sce.instalment': 'Terminbeløp',
  'pkn.sce.home.firstInterest': 'Rente først',
  'pkn.sce.home.value': 'Boligverdi',
  'pkn.sce.home.storySerial': 'En bolig til {price} med {equity} i egenkapital gir et lån på {loan} og et serielån med terminbeløp rundt {monthly} i måneden. Egenkapitalen bindes opp, men boligen bygger formue over tid.',
  'pkn.sce.home.storyAnnuity': 'En bolig til {price} med {equity} i egenkapital gir et lån på {loan} og et annuitetslån med terminbeløp rundt {monthly} i måneden. Egenkapitalen bindes opp, men boligen bygger formue over tid.',
  'pkn.sce.car.label': 'Kjøpe bil',
  'pkn.sce.car.price': 'Bilpris',
  'pkn.sce.car.depreciation': 'Verditap 5 år',
  'pkn.sce.car.story': 'En bil til {price} med {equity} i egenkapital gir et lån på {loan} og et terminbeløp rundt {monthly} i måneden. Bil taper verdi, så nettoformuen trekkes ned de første årene.',
  'pkn.sce.retire.label': 'Pensjonere tidligere',
  'pkn.sce.retire.field': 'Ønsket pensjonsalder',
  'pkn.sce.retire.statAge': 'Ønsket alder',
  'pkn.sce.retire.statEarlier': 'År tidligere',
  'pkn.sce.retire.statNeeded': 'Nødvendig ekstra',
  'pkn.sce.retire.storyNone': 'Med pensjonsalder {age} år følger du dagens plan — ingen ekstra sparing kreves.',
  'pkn.sce.retire.story': 'Vil du gå av ved {age} år — {years} år tidligere enn dagens plan — må du dekke rundt {gap} i ekstra pensjonsbehov. Det tilsvarer omtrent {required} ekstra sparing i måneden fra nå.',
  'pkn.sce.debt.label': 'Nedbetale gjeld',
  'pkn.sce.debt.today': 'Gjeld i dag',
  'pkn.sce.debt.extraField': 'Ekstra nedbetaling per måned',
  'pkn.sce.debt.statExtra': 'Ekstra nedbetaling',
  'pkn.sce.debt.statEarlier': 'Gjeldfri tidligere',
  'pkn.sce.yearsDecimal': '{years} år',
  'pkn.sce.debt.statInterest': 'Renter spart',
  'pkn.sce.debt.storyNone': 'Legg inn gjelden din for å se hvor mye raskere du blir gjeldfri med ekstra nedbetaling.',
  'pkn.sce.debt.storyNoExtra': 'Uten ekstra nedbetaling følger gjelden dagens nedbetalingsplan.',
  'pkn.sce.debt.story': 'Betaler du {extra} ekstra på gjelden hver måned, blir du gjeldfri rundt {years} år tidligere og sparer omtrent {interest} i renter.',
  'pkn.sce.preset.child.name': 'Barn',
  'pkn.sce.preset.child.note': 'Utstyr, barnehage og økte utgifter',
  'pkn.sce.preset.wedding.name': 'Bryllup',
  'pkn.sce.preset.wedding.note': 'Engangskostnad for feiringen',
  'pkn.sce.preset.leave.name': 'Lengre permisjon',
  'pkn.sce.preset.leave.note': 'Redusert inntekt en periode',
  'pkn.sce.preset.sabbatical.name': 'Sabbatsår',
  'pkn.sce.preset.sabbatical.note': 'Ett år uten lønnsinntekt',
  'pkn.sce.preset.partTime.name': 'Gå ned i stilling',
  'pkn.sce.preset.partTime.note': 'Varig lavere inntekt',
  'pkn.sce.preset.raise.name': 'Lønnsøkning',
  'pkn.sce.preset.raise.note': 'Mer å spare hver måned',
  'pkn.sce.preset.renovation.name': 'Oppussing',
  'pkn.sce.preset.renovation.note': 'Større engangskostnad på boligen',
  'pkn.sce.preset.inheritance.name': 'Arv eller bonus',
  'pkn.sce.preset.inheritance.note': 'Engangsbeløp inn (negativ kostnad)',
  'pkn.sce.planInfo': 'Dette er utgangspunktet alle scenariene regner fra. Endrer du planen, oppdateres prognosen, målene og pensjonsbildet automatisk og lagres for valgt år.',
  'pkn.sce.hintMonthlySave': 'Fast beløp du legger til side hver måned',
  'pkn.sce.hintExtraDebt': 'Ut over ordinære avdrag — bygger også nettoformue',
  'pkn.sce.hintTarget': 'Målet vi måler prognosen mot',
  'pkn.sce.hintReturn': 'Nøkternt langsiktig snitt — 3–4 % er vanlig',
  'pkn.sce.phAge': 'Din alder',
  'pkn.sce.phDesiredAge': 'Ønsket alder',
  'pkn.sce.pensionSpend': 'Forventet månedlig forbruk som pensjonist',
  'pkn.sce.pensionSpendHint': 'Brukes bare i pensjonsprognosen.',
  'pkn.sce.newEvent': 'Ny livshendelse',
  'pkn.sce.editEvent': 'Rediger livshendelse',
  'pkn.sce.add': 'Legg til',
  'pkn.sce.saveChanges': 'Lagre endringer',
  'pkn.sce.hintOneOff': 'Negativt tall = engangsinntekt',
  'pkn.sce.hintMonthlyEffect': 'Negativt = økt utgift / lavere inntekt',
  'pkn.sce.hintDuration': '0 = varig endring',
  'pkn.sce.newGoalDefault': 'Nytt mål',
  'pkn.sce.leverFixed': 'Fast månedlig sparing',
  'pkn.sce.leverSetUp': 'Sett opp fast sparing',
  'pkn.sce.goalPasses': '{name} passerer {amount}',
  'pkn.sce.newGoal': 'Nytt mål',
  'pkn.sce.editGoal': 'Rediger mål',
  'pkn.sce.createGoal': 'Opprett mål',
  'pkn.sce.linkSavings': 'Koble til sparekonto',
  'pkn.sce.linkSavingsHint': 'Når en konto er koblet, hentes spart beløp automatisk fra siste registrerte saldo.',
  'pkn.sce.noAccount': 'Ingen konto',
  'pkn.main.tab.idag': 'I dag',
  'pkn.main.tab.oversikt': 'Oversikt',
  'pkn.main.tab.forbruk': 'Forbruk',
  'pkn.main.tab.familie': 'Familie',
  'pkn.main.tab.fremtid': 'Fremtid',
  'pkn.main.tab.reports': 'Rapporter',
  'pkn.main.tab.assets': 'Eiendeler',
  'pkn.main.tab.gjeld': 'Gjeld',
  'pkn.main.tab.skatt': 'Skatt',
  'pkn.main.tab.import': 'Import',
  'pkn.main.tab.transaksjoner': 'Transaksjoner',
  'pkn.main.asset': 'Eiendel',
  'pkn.main.debt': 'Gjeld',
  'pkn.main.netWealth': 'Nettoformue',
  'pkn.main.in': 'Inn',
  'pkn.main.out': 'Ut',
  'pkn.main.loanPayments': 'Lånebetalinger',
  'pkn.main.savingsInvesting': 'Sparing/investering',
  'pkn.main.heroIntro': 'SuperPlumma hjelper deg og familien med sparing, budsjett, lån, pensjon og skattemelding — som en privat finansrådgiver tilgjengelig hele døgnet.',
  'pkn.main.loadFailed': 'Kunne ikke hente privatøkonomi.',
  'pkn.main.actionUnavailable': 'Handlingen er ikke tilgjengelig ennå.',
  'pkn.main.actionFailed': 'Handlingen feilet.',
  'pkn.main.taskUpdated': 'Oppgaven er oppdatert.',
  'pkn.main.choiceSaved': 'Valget er lagret og brukes i senere forslag.',
  'pkn.main.moveUnavailable': 'Kategoriflytting er ikke tilgjengelig ennå.',
  'pkn.main.movedRuleSaved': 'Transaksjoner flyttet og regel lagret.',
  'pkn.main.moved': 'Transaksjoner flyttet.',
  'pkn.main.moveFailed': 'Kunne ikke flytte transaksjonene.',
  'pkn.main.importUnavailable': 'Privatøkonomi-import er ikke tilgjengelig ennå.',
  'pkn.main.uploadedShowingYear': 'Kontoutskriften er lastet opp. Viser {year}.',
  'pkn.main.uploaded': 'Kontoutskriften er lastet opp.',
  'pkn.main.uploadFailed': 'Opplasting feilet.',
  'pkn.main.recatUnavailable': 'Ny kategorisering er ikke tilgjengelig ennå.',
  'pkn.main.recatAlreadyRight': '{count} var allerede riktig',
  'pkn.main.recatManual': '{count} er flyttet manuelt og ble ikke rørt',
  'pkn.main.recatStillOther': '{count} ligger fortsatt i «Annet»',
  'pkn.main.recatDone': '{done} av {total} transaksjoner fikk ny kategori',
  'pkn.main.recatFailed': 'Ny kategorisering feilet.',
  'pkn.main.bufferSaved': 'Buffermålet er lagret.',
  'pkn.main.budgetSaved': 'Budsjettet er lagret.',
  'pkn.main.householdSaved': 'Husholdningen er lagret.',
  'pkn.main.planSaved': 'Planen er lagret.',
  'pkn.main.assetSaved': 'Eiendel lagret.',
  'pkn.main.assetDeleted': 'Eiendel slettet.',
  'pkn.main.loanSaved': 'Lånet er lagret.',
  'pkn.main.loanDeleted': 'Lånet er slettet.',
  'pkn.main.taxChecklistSaved': 'Skattesjekklisten er lagret.',
  'pkn.main.accountSaved': 'Konto lagret.',
  'pkn.main.accountDeleted': 'Konto slettet med tilhørende kontoutskrifter.',
  'pkn.main.statementLinked': 'Kontoutskriften er koblet til konto.',
  'pkn.main.statementDeleted': 'Kontoutskriften er slettet.',
  'pkn.main.assistantUnavailable': 'Privatøkonomi-assistenten er ikke tilgjengelig.',
  'pkn.main.personalFinanceName': 'Privat økonomi',
  'pkn.fut.noEvents': 'Ingen livshendelser lagt inn ennå. Legg til en — for eksempel barn, boligkjøp eller et sabbatsår — så viser jeg hvordan den påvirker formuen og målene dine over tid.',
});
